import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, ScreenClassRender } from "react-grid-system";

class NoDifyMessage extends React.Component {

  getContainerStyle = (screenClass) => {
    const containerRightLeftPadding = {
      xs: 20,
      sm: 40,
      md: 40,
      lg: 40,
      xl: 80
    };
    return {
      containerPadding: `30px ${containerRightLeftPadding[screenClass]}px`,
      containerShadow: "0 4px 5px 0 rgba(0,0,0,0.15)",
      containerBorderRadius: "10px"
    }
  }

  render() {
    return (
      <ScreenClassRender
        render={screenClass => {
          return (
            <Container fluid style={this.getContainerStyle(screenClass)}>
              <Row>
                <Col><h2 style={{textAlign:'center'}}>This service is not accepting new orders at the moment.</h2></Col>
              </Row>
            </Container>
          )
        }}
      />
    );
  }
}



const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoDifyMessage);



// WEBPACK FOOTER //
// ./src/pages/NoDifyMessage.js